import { useEffect, useRef, useState } from "react";
import { registerErrorHandler } from "../../api/errorBus";
import { useTranslation } from "../../hooks/useTranslation";
import styles from "./ErrorToast.module.css";

interface Toast {
  id: number;
  message: string;
}

let nextId = 0;

export const ErrorToast = () => {
  const { t } = useTranslation();
  const tRef = useRef(t);
  tRef.current = t;
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    registerErrorHandler((message) => {
      const id = nextId++;
      setToasts((prev) => [...prev, { id, message: message ?? tRef.current("common.error") }]);
      window.setTimeout(() => {
        setToasts((prev) => prev.filter((item) => item.id !== id));
      }, 5000);
    });
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className={styles["container"]} role="alert" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className={styles["toast"]}>
          <span className={styles["message"]}>{toast.message}</span>
          <button
            type="button"
            className={styles["closeButton"]}
            onClick={() => setToasts((prev) => prev.filter((item) => item.id !== toast.id))}
            aria-label={t("common.close")}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};
